import { z } from "zod";

export const primaryRoles = [
  "OWNER",
  "TRAINER",
  "ASSISTANT_TRAINER",
  "RACING_MANAGER",
  "VET",
  "FARRIER",
  "RIDER",
  "GROOM",
  "VENDOR",
  "HEAD_LAD",
  "FEEDMAN",
  "TRAVELLING_LAD",
  "TRAVELLING_HEAD_LAD",
] as const;

export const PrimaryRoleSchema = z.enum(primaryRoles);

export type PrimaryRole = z.infer<typeof PrimaryRoleSchema>;

export const PublicAccountSchema = z
  .object({
    id: z.string().uuid(),
    displayName: z.string().nullable(),
    primaryRole: PrimaryRoleSchema.nullable(),
    discoverable: z.boolean(),
    platformRole: z.enum(["HORSEMAN", "ADMIN"]),
    subscriptionTier: z.enum(["FREE", "PRO"]),
    profileCompleted: z.boolean(),
    accountStatus: z.enum(["ACTIVE", "SUSPENDED"]),
    profilePictureUpdatedAt: z.string().datetime().nullable().default(null),
    profilePictureUrl: z.string().nullable().default(null),
    contactPoints: z.array(
      z
        .object({
          type: z.enum(["EMAIL", "PHONE"]),
          normalizedValue: z.string().min(1),
        })
        .strict(),
    ),
  })
  .strict();

export type PublicAccount = z.infer<typeof PublicAccountSchema>;
